const Routes_gral = {
    login: '/',
    home: '/Home',
    user: '/User',
    group: '/Group',
    product: '/Product',
    addReq: '/addReq',
    reqSector: '/reqSector',
    globalSettings: '/globalSettings',
    warehouse: '/warehouse',
    distribucion: '/distribucion',
    reportes: '/reportes',
}

export default Routes_gral